module.exports = __webpack_public_path__ + "img/Expiringsoon.a0b62f17.png";